import { render, staticRenderFns } from "./OrganisationSwitcher.vue?vue&type=template&id=4fb4a3e4"
import script from "./OrganisationSwitcher.vue?vue&type=script&lang=js"
export * from "./OrganisationSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports